import { useMemo, createContext, useContext, useState, useEffect } from "react";

import { contentByLanguage } from "../data/siteContent";
import type { SiteContent } from "../data/siteContent";
import type { Lang } from "../data/resolveContent";

const GlobalProvider = createContext({} as { language: Lang, setLanguage: (language: Lang) => void, content: SiteContent, [key: string]: any });

const GlobalStateProvider = ({ children }) => {

    const [language, setLanguage] = useState<Lang>(localStorage.getItem('language') as Lang || 'en');
    const [content, setContent] = useState<SiteContent>(contentByLanguage[language]);

    useEffect(() => {
        setContent(contentByLanguage[language]);
    }, [language]);

    const handleLanguage = (language: Lang) => {
        setLanguage(language);
        localStorage.setItem('language', language);

    }

    const memo = useMemo(() => ({
        language,
        setLanguage: handleLanguage,
        content
    }), [language, content]);

    return <GlobalProvider.Provider value={memo}>{children}</GlobalProvider.Provider>
}


export default GlobalStateProvider;

export const useGlobalContext = () => {
    return useContext(GlobalProvider);
}
